import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { SERVICES } from '../lib/site';

const FOOTER_VARS = {
    '--ink': '21 18 46',
    '--ink2': '21 18 46',
    '--surface': '27 23 58',
    '--line': '50 44 94',
    '--cream': '242 241 250',
    '--fog': '155 157 192',
    '--bronze': '154 160 245',
};

export default function Footer() {
    return (
        <footer data-testid="site-footer" style={FOOTER_VARS} className="border-t border-line bg-ink2">
            <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
                    <div className="lg:col-span-5">
                        <div>
                            <img src="/assets/commpro-logo-white.png" alt="CommPro Worldwide" className="h-[66px] w-auto" />
                            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-fog mt-3">
                                Architects of Influence — Est. 2015
                            </p>
                        </div>
                        <p className="mt-6 text-sm text-fog leading-relaxed max-w-md">
                            Integrated strategic program management and advisory — driving market
                            adoption, public-private partnerships, executive visibility, and lead
                            generation at scale for organizations shaping the global agenda.
                        </p>
                    </div>

                    <div className="lg:col-span-3">
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bronze mb-5">
                            Navigate
                        </p>
                        <ul className="space-y-3">
                            {['About', 'Services', 'Events', 'Media', 'Contact'].map((p) => (
                                <li key={p}>
                                    <Link
                                        to={`/${p.toLowerCase()}`}
                                        data-testid={`footer-link-${p.toLowerCase()}`}
                                        className="group inline-flex items-center gap-1 text-sm text-fog hover:text-cream transition-colors duration-300"
                                    >
                                        {p}
                                        <ArrowUpRight
                                            size={12}
                                            className="opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 text-bronze"
                                        />
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-bronze mb-5">
                            Practice Areas
                        </p>
                        <ul className="space-y-3">
                            {SERVICES.map((s) => (
                                <li key={s.id} className="text-sm text-fog">
                                    {s.title}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>

                <div className="mt-16 pt-8 border-t border-line flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                    <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-fog">
                        © 2026 CommPro Worldwide. All rights reserved.
                    </p>
                    <div className="flex items-center gap-6">
                        <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-fog">
                            New York · Washington · London · Geneva · Singapore
                        </span>
                        <Link
                            to="/admin"
                            data-testid="footer-admin-link"
                            className="font-mono text-[10px] uppercase tracking-[0.25em] text-fog hover:text-bronze transition-colors duration-300"
                        >
                            Admin
                        </Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}
